import React from 'react';
import PropTypes from 'prop-types';
import { SELECTED_MODIFIER } from '../constants';

const CartVariantSelect = ({
  variants,
  selectedVariant,
  totalPrice,
  handleOnChange,
  className
}) => {
  if (!variants || !variants.length || variants.length === 1) return null;

  return (
    <div className={`${className}__variant-select`}>
      <label htmlFor="cart-variant-select">{totalPrice}</label>
      <select id="cart-variant-select" onChange={handleOnChange} value={selectedVariant}>
        {variants.map(({ variantId, name }) => (
          <option
            key={variantId}
            value={variantId}
            className={`${className}__variant-select__option${
              variantId === selectedVariant ? SELECTED_MODIFIER : ''
            }`}>
            {name}
          </option>
        ))}
      </select>
    </div>
  );
};

CartVariantSelect.propTypes = {
  variants: PropTypes.array.isRequired,
  selectedVariant: PropTypes.string.isRequired,
  totalPrice: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  handleOnChange: PropTypes.func.isRequired,
  className: PropTypes.string.isRequired
};

export default CartVariantSelect;
